import React, { useEffect, useState } from "react";
import { useTUIKitContext, useTUIChatActionContext } from "@tencentcloud/chat-uikit-react";
import { TUIChatService } from "@tencentcloud/chat-uikit-engine";

import { ROBOT_ACTIVE_PAYLOAD, ROBOT_USERS, prompts } from "../../common/constants";

import "./BotPrompt.scss";

interface IBotPromptProps {
  activeConversationIDList: Array<string>;
  setActiveConversationID: (conversationID:string) => void;
}

export function BotPrompt(props: IBotPromptProps) {
  const { activeConversationIDList, setActiveConversationID } = props;
  const { setFirstSendMessage } = useTUIChatActionContext('BotCard');
  const { conversation } = useTUIKitContext('TUIChat');
  const [rendMap, setRendMap] = useState<any>({});

  const handleSendMessage = (key: string) => {
    const options: any = {
      payload: {
        text: rendMap[key],
      },
    };
    TUIChatService.sendTextMessage(options).then((res: any) => {
      const { message } = res.data;
      setFirstSendMessage && setFirstSendMessage(message);
    });
  }

  useEffect(() => {
    if (!conversation) {
      return;
    }

    const conversationID:string = conversation.conversationID || '';

    const userInfo = ROBOT_USERS.find((userInfo: any) => {
      return `C2C${userInfo.userID}` === conversationID;
    })

    setRendMap(prompts[userInfo?.key || 'chatbot']);

    if (!activeConversationIDList.includes(conversationID)) {
      TUIChatService.sendCustomMessage({
        payload: ROBOT_ACTIVE_PAYLOAD
       });
      setActiveConversationID(conversationID);
    }
  }, [activeConversationIDList, conversation, setActiveConversationID])

  return (
    <>
      <ul className="bot-prompt-list">
        {Object.keys(rendMap).map((item:string) => (
          <li
            key={item}
            className='bot-prompt-item'
            onClick={() => {
              handleSendMessage(item);
            }}
          >
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
